export default {
  Admin: 1,
  Notifications: 2,
  Restrictions: 3,
  Users: 4,
  Groups: 10,
  Cases: 5,
  Recommendations: 11,
  Agents: 9,
  Points: [7, 8],
  Settings: 12,
  Statistics: 13,
  Chat: 10,
  ProductStockSetting: 10,
  Drivers: 14,
  Monitorings: 15
}



// WEBPACK FOOTER //
// ./src/router/access-list.js